export default "__VITE_ASSET__RJiKRwr5__"